<template>
  <div class="py-8 md:p-[50px] lg:p-[100px]">
    <div
      class="w-full pt-[50px] lg:pt-[100px] flex flex-col gap-[10px] border-t-2"
    >
      <div
        class="w-full rounded-[20px] flex flex-col gap-[20px] items-center md:grid md:grid-cols-2 md:gap-[60px]"
      >
        <!-- Atlast image -->
        <div class="flex justify-center w-full">
          <img
            class="w-[200px] h-[200px] lg:w-[420px] lg:h-[420px]"
            :src="sliderData.image_path"
            alt=""
          />
        </div>

        <!-- Text Section -->
        <div class="w-full flex flex-col gap-[20px] text-center md:text-start">
          <h1 class="text-[24px] md:text-[32px] lg:text-[36px] font-bold">
            {{ getLocalized(contentData, "title") }}
          </h1>
          <p class="px-4 md:px-0 text-[16px] lg:text-[24px]">
            {{ getLocalized(contentData, "description") }}
          </p>
          <span class="mt-[40px]">
            <a
              href="/contact-us"
              class="w-[140px] h-[50px] px-[20px] py-[12px] text-sm md:text-base bg-tbt-blue gap-[10px] rounded-[60px] text-white md:w-[163px] md:h-[55px] lg:px-[32px] lg:py-[16px]"
            >
              {{ getLocalized(contentData, "title") }}
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchContentSection } from "@/composable/apiService";
import { fetchSlider } from "@/composable/apiService";
import contactRobot from "../assets/pictures/ttRobot.gif";
import { useLocalization } from "@/composable/useLocalization";
export default {
  data() {
    return {
      contentData: {},
      robot: contactRobot,
      currentLang: localStorage.getItem("language") || "en",
      sliderData: {},
      api: process.env.VUE_APP_API_KEY,
    };
  },

  mounted() {
    this.fetchContent();
    this.fetchingSlider();
  },

  methods: {
    async fetchContent() {
      try {
        this.contentData = await fetchContentSection(6);
      } catch (error) {
        console.error("Failed to fetch content" + error.message);
      }
    },
    async fetchingSlider() {
      try {
        const responseData = await fetchSlider(6); // Fetch the single object
        if (responseData) {
          this.sliderData = {
            ...responseData, // Spread the existing properties
            image_path: `${this.api}${responseData.image_path}`,
          };
        } else {
          console.warn("No slider found for the given ID.");
        }
      } catch (error) {
        console.error("Failed to fetch slider:", error.message);
      }
    },
  },

  computed: {
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
};
</script>
